import { Dispatch, SetStateAction } from "react";
import { Col, ColProps, Form } from "react-bootstrap";

function InputField<Value>({
  set,
  value,
  label,
  sizes,
  parse,
  type,
  disabled,
  min,
  max,
}: {
  set?: Dispatch<SetStateAction<Value>>;
  value: Value;
  label: string;
  sizes: ColProps;
  parse: (string: string) => Value;
  type?: string;
  disabled?: boolean;
  min?: number;
  max?: number;
}) {
  const string = String(value);
  return (
    <Form.Group className="auth-input mb-3" as={Col} {...sizes}>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type={type ? type : typeof value === "number" ? "number" : "text"}
        min={typeof value === "number" ? 0 : undefined}
        required
        minLength={min}
        maxLength={max}
        placeholder={label}
        disabled={disabled}
        value={string}
        onChange={(e) => {
          const coerced = parse(e.target.value);
          set ? set(coerced) : <></>;
        }}
      />
    </Form.Group>
  );
}

// <InputField value='one' set={x.set} label='x' parse={String} />
// <InputField value={1} set={y.set} label='y' parse={Number} />

export default InputField;
